// extracted by mini-css-extract-plugin
export var label = "_42-1";
export var reminder = "_42-0";